import { IAdvertiserInClientFormData, IClientAdvertiserPayload } from '@/Interfaces/Client.interface';
import ModalHeaderIcon from '@/components/Icons/ModalHeaderIcon';
import LoadingBackdropWrapper from '@/components/Modal/common/LoadingBackdropWrapper';
import ModalTitleCard from '@/components/Modal/common/ModalTitleCard';
import AddAdvertiserInfo from '@/pages/Clients/AddAdvertiserModal/AddAdvertiserInfo';
import { Button, Dialog, DialogContent } from '@mui/material';
import { useCallback } from 'react';
import { FormProvider, UseFormReturn } from 'react-hook-form';

interface IProps {
  form: UseFormReturn<IAdvertiserInClientFormData>;
  open: boolean;
  onClose: (advertiser: IClientAdvertiserPayload | null) => void;
  loading: boolean;
  clientId?: number;
}

const AddAdvertiserModal = ({ form, open, onClose, loading }: IProps) => {
  const { handleSubmit, reset } = form;
  const onSubmit = useCallback(
    async ({ name, category, domain, alternativeId }: IAdvertiserInClientFormData) => {
      const payload: IClientAdvertiserPayload = {
        name,
        domain,
        alternativeId,
        temporaryKey: Date.now(),
        category: category!.value,
        agencyId: null,
      };
      onClose(payload);
      reset();
    },
    [onClose, reset],
  );

  const handleClose = useCallback(() => {
    onClose(null);
    reset();
  }, [onClose, reset]);

  return (
    <LoadingBackdropWrapper backdropOpen={loading}>
      <Dialog maxWidth={false} open={open} onClose={handleClose} aria-labelledby='modal-title'>
        <DialogContent sx={{ width: '650px', overflow: 'hidden' }}>
          <ModalTitleCard titleIcon={<ModalHeaderIcon />} handleClose={handleClose} title='Create New Advertiser' />
          <FormProvider {...form}>
            <form className='mt-4' onSubmit={handleSubmit(onSubmit)}>
              <AddAdvertiserInfo />
              <hr className='-mx-[32px] my-5' />
              <div className='mt-5 flex justify-end gap-[12px]'>
                <Button color='inherit' variant='outlined' onClick={handleClose}>
                  Cancel
                </Button>
                <Button color='primary' variant='contained' type='submit'>
                  Create
                </Button>
              </div>
            </form>
          </FormProvider>
        </DialogContent>
      </Dialog>
    </LoadingBackdropWrapper>
  );
};

export default AddAdvertiserModal;
